import { Link } from "react-router-dom";
import { LanguageToggle } from "@/components/LanguageToggle";
import { useLanguage } from "@/contexts/LanguageContext";

/**
 * Landing V2 — Minimal top bar.
 * No logo, no nav. Just language toggle + Sign in. Fades into the dark canvas.
 */
export function MinimalTopBar() {
  const { t } = useLanguage();

  return (
    <header className="absolute top-0 inset-x-0 z-10">
      <div className="max-w-5xl mx-auto px-6 py-3 flex items-center justify-end gap-4">
        <LanguageToggle onGradientBackground />
        <Link
          to="/?auth=true"
          className="text-sm text-muted-foreground hover:text-foreground transition-colors"
        >
          {t("landing.signIn")}
        </Link>
      </div>
    </header>
  );
}
